// Slovenian texts of the "Ročno" module. Merged by the shell under the `rocno` key of sl.ts
// (`rocno: slRocno`), so code uses t('rocno.xxx').
export default {
  quickPick: {
    empty: 'Seznam je prazen.',
    showAll: 'Prikaži vse (še {n})',
    hideAll: 'Skrij ostale',
    search: 'Poišči …',
    noMatches: 'Ni zadetkov.',
  },
  step: {
    pick: 'Izberi',
    write: 'Vpiši',
    required: 'obvezno',
    optional: 'neobvezno',
  },
  filter: {
    allAreas: 'Vsa področja',
  },
  validation: {
    required: 'Obvezno polje',
    maxLength: 'Največ {n} znakov',
    area: 'Izberi področje',
    date: 'Vpiši veljaven datum',
    time: 'Vpiši uro (npr. 07:00)',
    material: 'Izberi material',
    nonNegative: 'Količina ne sme biti negativna',
    sorters: 'Izberi vsaj eno osebo',
    counters: 'Izberi vsaj eno osebo',
    endAfterStart: 'Konec mora biti po začetku',
  },
  missing: {
    area: 'področje',
    material: 'material',
    time: 'začetek in konec',
    sorters: 'kdo je sortiral',
    counters: 'kdo je popisal',
    items: 'vsaj ena postavka s količino',
  },
  rows: {
    qty: 'Količina (kg)',
    qtyPlaceholder: 'npr. 85',
    remove: 'Odstrani',
    incomplete: 'Vrstica, kjer manjka vrsta ali količina, ne bo shranjena.',
  },
  addModal: {
    name: 'Ime',
    placeholder: 'Vpiši ime …',
    added: 'Dodano: {name}',
    title: {
      materials_bk: 'Dodaj material (Barvne kovine)',
      materials_zs: 'Dodaj material (Zunanje skladišče)',
      suppliers: 'Dodaj dobavitelja',
      fractions: 'Dodaj frakcijo',
      workers: 'Dodaj delavca',
    },
  },
  images: {
    dropHere: 'Povleci slike sem',
    or: 'ali',
    browse: 'Poišči slike v računalniku',
    uploading: 'Nalagam slike ({n}) …',
    failed: 'Nekaterih slik ni bilo mogoče naložiti',
    tooMany: 'Na vnos lahko dodaš največ {n} slik.',
    error: {
      type: 'dovoljene so le slike JPG, PNG, WEBP ali GIF',
      size: 'slika je večja od 10 MB',
      failed: 'nalaganje ni uspelo, poskusi znova',
    },
    open: 'Odpri sliko',
    remove: 'Odstrani sliko',
    retry: 'Poskusi znova',
    preview: 'Slika',
    previous: 'Prejšnja slika',
    next: 'Naslednja slika',
  },
  newEntry: {
    title: 'Nov vnos: Ročno',
    subtitle: 'Reši korake od zgoraj navzdol. »Izberi« pomeni tapni ponujeno, »Vpiši« pomeni napiši sam.',
    area: {
      title: 'Področje',
      sub: 'Kje poteka sortiranje?',
    },
    what: {
      title: 'Kaj sortiramo',
      sub: 'Tapni material in dobavitelja. Ni ga na seznamu? Pod seznamom ga dodaš.',
      material: 'Vhodni material',
      supplier: 'Dobavitelj materiala',
      pickAreaFirst: 'Najprej izberi področje (korak 1), potem se pokažejo njegovi materiali.',
      searchMaterial: 'Poišči material …',
      searchSupplier: 'Poišči dobavitelja …',
      addMaterial: '+ Dodaj nov material',
      addSupplier: '+ Dodaj dobavitelja',
    },
    when: {
      title: 'Kdaj',
      sub: 'Datum in ura začetka ter konca.',
      date: 'Datum',
      start: 'Začetek (ura)',
      end: 'Konec (ura)',
      duration: 'Trajanje',
    },
    qtyIn: {
      title: 'Količina vhoda',
      sub: 'Če količina ni znana, polje pusti prazno.',
      label: 'Koliko kg je bilo vhodnega materiala',
      placeholder: 'npr. 450',
    },
    out: {
      title: 'Kaj smo presortirali ven',
      sub: 'Za vsako izločeno frakcijo izberi vrsto in vpiši kilograme.',
      row: 'Frakcija',
      type: 'Vrsta frakcije',
      addRow: 'Dodaj še eno frakcijo',
      addFraction: '+ Dodaj novo frakcijo',
      searchFraction: 'Poišči frakcijo …',
      remainder: 'Preostanek (neizločeno)',
      tooMuch: 'Izločeno je več kot vhodna količina!',
      tooMuchBy: 'Presežek: {kg}',
    },
    team: {
      title: 'Ekipa',
      sub: 'Tapni imena vseh, ki so sortirali. Izbrani so obarvani.',
      sorters: 'Kdo je sortiral',
      forklift: 'Ali je bil prisoten viličarist',
      searchWorker: 'Poišči delavca …',
      addWorker: '+ Dodaj delavca',
    },
    notes: {
      title: 'Opombe',
      label: 'Opombe',
      placeholder: 'Vpiši, kar je še pomembno (npr. večji delež INOX-a) …',
    },
    images: {
      title: 'Slike',
      sub: 'Dokazilo, stanje materiala … Slike ostanejo shranjene v evidenci.',
    },
    missing: 'Še manjka:',
    ready: 'Vse obvezno je izpolnjeno',
    save: 'Shrani vnos',
    saved: 'Vnos shranjen',
    reset: 'Prekliči in počisti obrazec',
  },
  log: {
    title: 'Evidenca vnosov',
    subtitle: '{shown} od {total} vnosov',
    newEntry: 'Nov vnos',
    search: 'Išči po materialu ali delavcu …',
    empty: 'Ni vnosov za izbrani filter.',
    period: {
      today: 'Danes',
      week: 'Ta teden',
      month: 'Ta mesec',
      all: 'Vse',
    },
    area: 'Področje',
    date: 'Datum',
    time: 'Ura',
    material: 'Material',
    sorters: 'Sortirali',
    duration: 'Trajanje',
    qtyIn: 'Vhod',
    out: 'Izločeno',
    remainder: 'Preostanek',
    total: 'Skupaj',
    unknownQty: 'ni znano',
    supplier: 'Dobavitelj',
    forklift: 'Viličarist',
    forkliftYes: 'Da, bil je prisoten',
    forkliftNo: 'Ni bil prisoten',
    createdBy: 'Vnesel',
    fractions: 'Izločene frakcije',
    noFractions: 'Ni izločenih frakcij.',
    notes: 'Opombe',
    images: 'Slike',
    detailTitle: 'Podrobnosti vnosa',
  },
  overview: {
    title: 'Pregled: Ročno',
    subtitle: 'Stanje za danes, {date}, in zadnjih 7 dni.',
    entriesToday: 'Vnosov danes',
    qtyInToday: 'Sortirano danes',
    qtyInSub: 'vhodna količina, vsi vnosi',
    qtyOutToday: 'Izločeno danes',
    qtyOutSub: 'vse frakcije skupaj',
    noEntriesYet: 'še ni vnosov',
    last7: 'Zadnjih 7 dni',
    entries: 'Vnosov',
    byMaterial: 'Po materialu (vhod)',
    byFraction: 'Po frakciji (izločeno)',
    noData: 'Ni podatkov.',
  },
  stocktake: {
    title: 'Inventura',
    subtitle: 'Zadnje popisane količine na zalogi, ločeno po področjih.',
    new: 'Nova inventura',
    area: 'Področje',
    date: 'Datum popisa',
    counters: 'Kdo je popisal',
    items: 'Postavke in količine na zalogi',
    item: 'Postavka',
    addItem: 'Dodaj postavko',
    notes: 'Opombe',
    save: 'Shrani inventuro',
    saved: 'Inventura shranjena',
    last: 'Zadnja inventura: {area}',
    noneYet: 'Za to področje še ni bila opravljena inventura.',
    history: 'Zgodovina popisov',
    historyEmpty: 'Ni popisov za izbrano področje.',
    counted: 'Popisali',
    itemCount: 'Postavk',
    detail: 'Podrobnosti inventure',
  },
}
